import { Button, Divider, Paper, IconButton, CircularProgress } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../../components/global/Header';
import { Box } from '@mui/system';
import Logo from '../../assets/Images/dummy-company.png';
import client from '../../API/client';
import Colors from '../../Constant/Colors';
import { UserContextData } from '../../context/AuthContext';
import moment from 'moment/moment';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./Designer.css"

export const DesignerJobs = () => {
  const [jobdata, setJobsData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchdata, setSearchData] = useState([]);
  const [isData, setData] = useState(false);
  const [issData, setSData] = useState(false);
  const { Designer } = useContext(UserContextData);

  const jobApplicant = async ({ jobpost_id, recruiter_id }) => {
    const designer_id = await Designer.designer_id;
    const Payload = { jobpost_id, recruiter_id, designer_id };
    try {
      await client
        .post(`/designer/job-apply`, Payload, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
        })
        .then(async (res) => {
          toast.success('Succesfully applied !!', {
            position: toast.POSITION.TOP_CENTER,
          });
        });
    } catch (error) {
      toast.error('Oops!! something went wrong', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(() => {
    getjobsData();
  }, []);

  const getjobsData = async () => {
    setData(true);
    try {
      await client
        .get('/designer/job-post', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(async (res) => {
          setData(false);
          setJobsData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      toast.error('Oops!! something went wrong', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleSearchSubmit = async (e) => {
    setSData(true);
    // console.log(searchTerm);
    try {
      const response = await client.get(`/designer/job-post/search?term=${searchTerm}`);
      if (response) {
        setSearchData(response.data);
        setSData(false);
      }

      // console.log(response.data);
    } catch (error) {}
  };

  return (
    <>
      <Container fluid style={{ padding: '20px' }}>
        <ToastContainer />

        <Header subtitle="Jobs based on your profile" />
        {/* <Box display="flex" backgroundColor={'whitesmoke'} borderRadius="25px" width="30%" height="50px" mb="20px" mt="10px">
          <InputBase sx={{ ml: 2, flex: 1, color: '#3F3D56' }} placeholder="Search Job" onChange={(e) => setSearchTerm(e.target.value)} />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
          <Button sx={{ color: '#3F3D56' }} onClick={() => handleSearchSubmit()}>
            search
          </Button>
        </Box> */}
        <div class="search-box">
          <button class="btn-search" onClick={() => handleSearchSubmit()}>
          <SearchIcon />
          </button>
          <input type="text" class="input-search" placeholder="Type to Search..." onChange={(e) => setSearchTerm(e.target.value)}/>
        </div>
        <Paper
          elevation={5}
          style={{
            padding: '20px',
            height: '650px',
            overflow: 'scroll',
            backgroundColor: 'whitesmoke',
            marginTop: '10px',
          }}>
          {searchdata.length === 0 ? (
            ''
          ) : (
            <div>
              <h4>Search Result</h4>
            </div>
          )}
          <>{issData ? <CircularProgress /> : ''}</>
          {searchdata.map((data) => (
            <div key={data.jobpost_id}>
              <Accordion sx={{ mb: '10px', mt: '10px' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Box>
                    <Box
                      sx={{
                        flexDirection: 'row',
                        padding: '10px',
                        display: 'flex',
                        gap: '20px',
                      }}>
                      <img
                        alt="company logo"
                        src={Logo}
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      <div style={{ flexDirection: 'column', display: 'flex' }}>
                        <span style={{ fontSize: '25px', color: Colors.primary }}>
                          {data.jobtitle}{' '}
                          <span
                            style={{
                              fontSize: '18px',
                              marginLeft: '10px',
                              color: 'green',
                            }}>
                            {moment(data.createdat).fromNow()}
                          </span>
                        </span>
                        <span style={{ fontSize: '18px', color: 'grey' }}>{data.company_name}</span>
                        <div
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingTop: '5px',
                          }}>
                          <span>{data.jobtype} </span>
                          <span style={{ paddingLeft: '10px' }}>{data.jobsalary} </span>
                          <span style={{ paddingLeft: '10px' }}>{data.workplace_type} </span>
                        </div>
                      </div>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails sx={{ mb: '10px' }}>
                  <Box sx={{ padding: '10px' }}>
                    <div style={{ marginTop: '20px' }}>
                      <h4>Recruiter Details</h4>
                    </div>
                    <div className="post-details">Posted By :- {data.r_fullname}</div>
                    <div className="post-details">Email :- {data.r_email}</div>
                    <div style={{ marginTop: '20px' }}>
                      <h4>About</h4>
                    </div>
                    <div className="post-details">{data.jobabout}</div>
                    <div style={{ marginTop: '20px' }}>
                      <h4>Requirement</h4>
                    </div>
                    <div className="post-details">{data.jobrequirement}</div>
                    <Button
                      onClick={() =>
                        jobApplicant({
                          jobpost_id: data.jobpost_id,
                          recruiter_id: data.recruiter_id,
                        })
                      }
                      variant="contained"
                      sx={{
                        marginTop: '25px',
                        borderRadius: 1,
                        letterSpacing: 1,
                      }}>
                      Easy apply
                    </Button>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
          <div>
            <h4>Recently posted</h4>
          </div>
          <>{isData ? <CircularProgress /> : ''}</>
          {jobdata.map((data) => (
            <div key={data.jobpost_id}>
              <Accordion sx={{ mb: '10px', mt: '10px' }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                  <Box>
                    <Box
                      sx={{
                        flexDirection: 'row',
                        padding: '10px',
                        display: 'flex',
                        gap: '20px',
                      }}>
                      <img
                        alt="company logo"
                        src={Logo}
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      <div style={{ flexDirection: 'column', display: 'flex' }}>
                        <span style={{ fontSize: '25px', color: Colors.primary }}>
                          {data.jobtitle}{' '}
                          <span
                            style={{
                              fontSize: '18px',
                              marginLeft: '10px',
                              color: 'green',
                            }}>
                            {moment(data.createdat).fromNow()}
                          </span>
                        </span>
                        <span style={{ fontSize: '18px', color: 'grey' }}>{data.company_name}</span>
                        <div
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingTop: '5px',
                          }}>
                          <span>{data.jobtype} </span>
                          <span style={{ paddingLeft: '10px' }}>{data.jobsalary} </span>
                          <span style={{ paddingLeft: '10px' }}>{data.workplace_type} </span>
                        </div>
                      </div>
                    </Box>
                  </Box>
                </AccordionSummary>

                <AccordionDetails sx={{ mb: '10px' }}>
                  <Box sx={{ padding: '10px' }}>
                    <div style={{ marginTop: '20px' }}>
                      <h4>Recruiter Details</h4>
                    </div>
                    <div className="post-details">Posted By :- {data.r_fullname}</div>
                    <div className="post-details">Email :- {data.r_email}</div>
                    <div style={{ marginTop: '20px' }}>
                      <h4>About</h4>
                    </div>
                    <div className="post-details">{data.jobabout}</div>
                    <div style={{ marginTop: '20px' }}>
                      <h4>Requirement</h4>
                    </div>
                    <div className="post-details">{data.jobrequirement}</div>
                    <Button
                      onClick={() =>
                        jobApplicant({
                          jobpost_id: data.jobpost_id,
                          recruiter_id: data.recruiter_id,
                        })
                      }
                      variant="contained"
                      sx={{
                        marginTop: '25px',
                        borderRadius: 1,
                        letterSpacing: 1,
                      }}>
                      Easy apply
                    </Button>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
        </Paper>
      </Container>
    </>
  );
};
